export default __webpack_public_path__ + "static/media/landing-page-background.37268b1a.png";